<script>
    import { Tooltip } from "carbon-components-svelte";
    export let text;
</script>

{#if text != ""}
    <div class="infotooltip">
        <Tooltip align="end"
            ><p>
                {text}
            </p></Tooltip
        >
    </div>
{/if}

<style>
    .infotooltip {
        float: right;
        position: relative;
        padding-right: 15px;
        font-family: Arial, sans-serif;
        user-select: text;
        /* Arial used instead of Mayeka Regular Demo because it doesn't show period symbols correctly */
    }
</style>
